var map = {
	"./cheer_up_0.png": 2256,
	"./cheer_up_1.png": 1485,
	"./cheer_up_2.png": 4984,
	"./cheer_up_3.png": 3022,
	"./cheer_up_4.png": 3015,
	"./cheer_up_5.png": 1993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6071;